import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "./components/SmoothScroll";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Golvlaggning from "./pages/Golvlaggning";
import ByggRenovering from "./pages/ByggRenovering";
import Projekt from "./pages/Projekt";
import Kontakt from "./pages/Kontakt";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/golvlaggning" element={<Golvlaggning />} />
              <Route path="/bygg-renovering" element={<ByggRenovering />} />
              <Route path="/projekt" element={<Projekt />} />
              <Route path="/kontakt" element={<Kontakt />} />
            </Routes>
          </main>
          <Footer />
        </SmoothScroll>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              borderRadius: 0,
              border: "1px solid rgba(18,18,18,0.15)",
              background: "#F7F6F2",
              color: "#121212",
              fontFamily: "Satoshi, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
